import { LocationVarKey } from "@swivl-mono/types";

import { IS_NOT_EQUAL, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { InputRow, PageHeader, SwitchRow, TextAreaRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.CTAMessage1,
  LocationVarKey.CTAMessage2,
  LocationVarKey.CTAMessage3,
  LocationVarKey.CTAhasURLNavigateTo,
  {
    key: LocationVarKey.CTAURLNavigateTo,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CTAhasURLNavigateTo, "1")
  },
  {
    key: LocationVarKey.CTAURLNavigateToMessage1,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CTAhasURLNavigateTo, "1")
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Custom Call To Action
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.CTAMessage1} />

      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.CTAMessage2}
        enableSwitchVar={LocationVarKey.CTAMessage2Enabled}
      />

      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.CTAMessage3}
        enableSwitchVar={LocationVarKey.CTAMessage3Enabled}
      />

      <SwitchRow {...page} keyName={LocationVarKey.CTAhasURLNavigateTo} label="Navigate to Url" />
      <InputRow
        {...page}
        keyName={LocationVarKey.CTAURLNavigateTo}
        label="Navigate to URL"
        hideIf={IS_NOT_EQUAL(LocationVarKey.CTAhasURLNavigateTo, "1")}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.CTAhasURLNavigateTo, "1")}
        marginTop
        label=" Menu Message"
        keyName={LocationVarKey.CTAURLNavigateToMessage1}
      />
    </>
  );
}
